import { DESIGN_IDEA_TAGS } from "../../_constants/designIdeaTags";

const DP_HEADERS = {
  "x-internal-client": "DIGITAL_PROFILE",
  "x-channel": "CONTRACTOR_WEB",
  "Content-Type": "application/json",
  "accept-version": "v1",
  "accept-language": "en",
};

const PATH = "/v1/api/design-idea-galleries/fetch-by-tag";

const PAGE_SIZE = 20;
// Detail page pulls a bigger first page so most `[id]`s resolve server-side.
export const DETAIL_PAGE_SIZE = 100;

export const resolveCategoryTagId = (slug) =>
  DESIGN_IDEA_TAGS.find((tag) => tag.slug === slug)?.tagId ?? null;

const EMPTY_PAGE = { items: [], nextOffset: undefined };

// Shaped like the old feed items so CategoryFeedGrid renders them unchanged.
function toPage(json, offset, pageSize) {
  const data = json?.result?.data;
  const images = data?.content?.[0]?.images ?? [];
  const items = images.map((image) => ({
    mediaGalleryId: image.id,
    mediaUrl: image.s3Url,
    tags: [],
  }));
  return { items, nextOffset: data?.last === false && items.length ? offset + pageSize : undefined };
}

async function request(baseUrl, { tagId, offset, pageSize, extra }) {
  try {
    const response = await fetch(`${baseUrl}${PATH}`, {
      method: "POST",
      headers: DP_HEADERS,
      body: JSON.stringify({ tagId, pageSize, offset }),
      ...extra,
    });
    if (!response.ok) return EMPTY_PAGE;
    return toPage(await response.json(), offset, pageSize);
  } catch (error) {
    console.error("Error fetching design idea images:", error);
    return EMPTY_PAGE;
  }
}

/** Server-side fetch — needs the absolute backend URL (no rewrites server-to-server). */
export const fetchDesignIdeaImages = ({ tagId, offset = 0, pageSize = PAGE_SIZE }) =>
  request(process.env.NEXT_PUBLIC_BASE_URL, { tagId, offset, pageSize, extra: { next: { revalidate: 60 } } });

/** Client-side fetch through the `/v1/api/:path*` rewrite (same-origin). */
export const fetchDesignIdeaImagesClient = ({ tagId, offset = 0 }) =>
  request("", { tagId, offset, pageSize: PAGE_SIZE });
